export const CART_ACTIONS = {
  SET_CART_ITEMS: 'cart/SET_CART_ITEMS',
  TOGGLE_CART_DISPLAY: 'cart/TOGGLE_CART_DISPLAY'
};
